<template>
  <div>
    <search-condition @searchConditionChange="searchConditionChange" :order-tab="type"></search-condition>
    <el-divider />
    <div class="table">
      <el-table :data="tableData" style="width: 100%" :header-cell-style="{background: '#F6FBFF', color: '#3381FF'}"
        v-loading="loading" :row-class-name="tableRowClassName">
        <el-table-column prop="order_sn" label="订单号" align="center">
        </el-table-column>
        <el-table-column prop="name" label="病人姓名" align="center">
        </el-table-column>
        <el-table-column prop="sex" :formatter="getPatientMsg" label="病人信息" align="center">
        </el-table-column>
        <el-table-column prop="location" :formatter="getLocation" label="位置信息" align="center">
        </el-table-column>
        <!-- <el-table-column prop="department_id" :formatter="getDepartment" label="科室/部位" align="center">
        </el-table-column> -->
        <el-table-column prop="create_date" :formatter="getCreateTime" label="发起时间" align="center">
        </el-table-column>
        <el-table-column prop="isQC" label="质控等级" align="center" >
          <template slot-scope="scope">
            <div v-if="type === 0 || type === 1 || type === 4">
              <el-dropdown @command="changeQC">
                <el-button v-if="scope.row.isQC === 1" style="color: #00CDCD; font-weight: bold">一级<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                <el-button v-else-if="scope.row.isQC === 2" style="color: #CD853F; font-weight: bold">二级<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                <el-button v-else-if="scope.row.isQC === 3" style="color: #8B475D; font-weight: bold">三级<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                <el-button v-else-if="scope.row.isQC === -1" style="color: #0091ea; font-weight: bold">待质控<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                <el-button v-else style="color: #84bf96; font-weight: bold">正常<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-if="scope.row.isQC != -1" :command="beforeHandleCommand(scope.row, -1)">待质控</el-dropdown-item>
                  <el-dropdown-item v-if="scope.row.isQC != 0" :command="beforeHandleCommand(scope.row, 0)">正常</el-dropdown-item>
                  <el-dropdown-item v-if="scope.row.isQC != 1" :command="beforeHandleCommand(scope.row, 1)">一级</el-dropdown-item>
                  <el-dropdown-item v-if="scope.row.isQC != 2" :command="beforeHandleCommand(scope.row, 2)">二级</el-dropdown-item>
                  <el-dropdown-item v-if="scope.row.isQC != 3" :command="beforeHandleCommand(scope.row, 3)">三级</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div v-if="type === 2 || type === 3 || type === 5">
              <span v-if="scope.row.isQC === 1" style="color: #00CDCD; font-weight: bold">一级</span>
              <span v-else-if="scope.row.isQC === 2" style="color: #CD853F; font-weight: bold">二级</span>
              <span v-else-if="scope.row.isQC === 3" style="color: #8B475D; font-weight: bold">三级</span>
              <span v-else-if="scope.row.isQC === -1" style="color: #0091ea; font-weight: bold">待质控</span>
              <span v-else style="color: #84bf96; font-weight: bold">正常</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="prescribeStatus" label="是否质控" align="center" >
          <template slot-scope="scope">
            <div v-if="type === 0 || type === 1 || type === 4">
              <el-dropdown @command="changePrescribe">
                <!-- <el-button v-if="scope.row.prescribeStatus === 1" style="color: #00CDCD; font-weight: bold">养护方案<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                <el-button v-else-if="scope.row.prescribeStatus === 2" style="color: #CD853F; font-weight: bold">抑制方案<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                <el-button v-else-if="scope.row.prescribeStatus === 3" style="color: #8B475D; font-weight: bold">治疗方案<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                <el-button v-else style="color: #0091ea; font-weight: bold">未开药<i class="el-icon-arrow-down el-icon--right"></i></el-button> -->
                <el-button v-if="scope.row.isChange === 0" style="color: #00CDCD; font-weight: bold">未质控<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                <el-button v-else-if="scope.row.isChange === 1" style="color: #CD853F; font-weight: bold">已质控<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                <el-dropdown-menu slot="dropdown">
                  <!-- <el-dropdown-item v-if="scope.row.prescribeStatus != 0" :command="beforeHandleCommand(scope.row, 0)">未开药</el-dropdown-item>
                  <el-dropdown-item v-if="scope.row.prescribeStatus != 1" :command="beforeHandleCommand(scope.row, 1)">养护方案</el-dropdown-item>
                  <el-dropdown-item v-if="scope.row.prescribeStatus != 2" :command="beforeHandleCommand(scope.row, 2)">抑制方案</el-dropdown-item>
                  <el-dropdown-item v-if="scope.row.prescribeStatus != 3" :command="beforeHandleCommand(scope.row, 3)">治疗方案</el-dropdown-item>
                </el-dropdown-menu> -->
                <el-dropdown-item v-if="scope.row.isChange != 0":command="beforeHandleCommand(scope.row, 0)">未质控</el-dropdown-item>
                <el-dropdown-item v-if="scope.row.isChange != 1":command="beforeHandleCommand(scope.row, 1)">已质控</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
            </div>
            <div v-if="type === 2 || type === 3 || type === 5">
              <span v-if="scope.row.isChange === 1" style="color: #00CDCD; font-weight: bold">已质控</span>
              <!-- <span v-else-if="scope.row.prescribeStatus === 2" style="color: #CD853F; font-weight: bold">抑制方案</span>
              <span v-else-if="scope.row.prescribeStatus === 3" style="color: #8B475D; font-weight: bold">治疗方案</span> -->
              <span v-else style="color: #0091ea; font-weight: bold">未质控</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="techName" label="技师名字" align="center">
        </el-table-column>
        <el-table-column prop="status" label="订单状态" align="center" v-if="type === 3">
          <template slot-scope="scope">
            <span v-if="scope.row.status === 0" style="color: orange">待支付</span>
            <span v-if="scope.row.status === 1" style="color: yellowgreen">待接单</span>
            <span v-if="scope.row.status === 2" style="color: green">待检查</span>
            <span v-if="scope.row.status === 3" style="color: blue">待出报告</span>
            <span v-if="scope.row.status === 4" style="color: #8B475D">已上传</span>
            <span v-if="scope.row.status === 5" style="color: purple">报告已出</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" align="center">
          <template slot-scope="scope">
            <el-button v-if="type === 0 || type === 4" @click="handlePreview(scope.row, scope.$index)" size="small" type="success" plain :disabled="isDisable(scope.row)">预览</el-button>
            <el-button v-if="type === 0" style="margin-left: 0" @click="payNewOrder(scope.row)" size="small" type="primary">完成支付</el-button>
            <el-button v-if="type === 4" style="margin-left: 0" @click="handleClick(scope.row)" size="small" type="primary">接单</el-button>
            <el-button v-if="scope.row.status === 3 && type === 1 || type === 6" @click="editReport(scope.row, scope.$index)" size="small" type="primary">编辑报告</el-button>
            <el-button v-if="scope.row.status === 3 && type === 1" @click="refundOrder(scope.row)" size="small" type="danger">退还</el-button>
            <el-button v-else-if="scope.row.status === 5 && type === 1" @click="checkReport(scope.row)" size="small" type="success">查看报告</el-button>
            <el-button v-if="type === 2 || type === 3 || type === 5" @click="viewReport(scope.row, scope.$index)" size="small" type="primary" plain :disabled="isDisable(scope.row)">预览</el-button>
            <!-- <el-button v-if="type === 2" style="margin-left: 0" @click="checkReport(scope.row, scope.$index)" size="small" type="success">查看</el-button> -->
            <el-button v-if="type === 2 ||type === 3 " style="margin-left: 0" @click="onLookPdf(scope.row.url)" size="small" type="success">查看报告</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination class="page" background layout="total, prev, pager, next" :page-count="total" :current-page="pageNum"
                     @current-change="handleCurrentChange">
      </el-pagination>
      <el-pagination class="page-phone" :pager-count="5" small layout="total, prev, pager, next" :page-count="total" :current-page="pageNum"
                     @current-change="handleCurrentChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import JsUtill from '../utils/JsUtill'
import SearchCondition from './order/SearchCondition'
import { getDepartmentList, getPresetList, getUserInfo, getOrder,
  controllerOrder, changePrescribe, getOrderList, payOrder,refundOrder} from '../../request/api'

export default {
  name: 'Order',
  components: {SearchCondition},
  props: {
    type: Number
  },
  async mounted () {
    // 获取当前医院ID
    await this.getHospitalId()
    await this.getDepartmentList()
    await this.getPresetList()
    // 请求专家可接全部类型订单数据
    this.getOrderList()
  },
  activated () {
    this.getOrderList()
  },
  watch: {
    type (newValue, oldValue) {
      this.pageNum = 1
      this.selectedIndex = -1
      this.getOrderList()
    }
  },
  data () {
    return {
      // 科室选择
      options_02: [
        {
          value: 0,
          label: '全部'
        }
      ],
      // 部位选择
      options_03: [
        {
          value: 20,
          label: '全部'
        }
      ],
      currentHospitalId: '',
      tableData: [],
      total: 1,
      page: 1,
      pageNum: 1,
      pageSize: 10,
      loading: false,
      selectedIndex: -1,
      isShow: true,
    }
  },
  methods: {
    // 查看报告
    onLookPdf(url){
      if(url != null && url != ''){
      // this.$router.push({ path: "/pdfView",  query: {orderSn: val.order_sn, fileName: val.filename, pdfUrl: val.url}})
      window.open(url, '_blank')
      }else{
        this.$message.error('该病例没有上传报告，无法查看')
      }
    },

    async getDepartmentList () {
      let resp = await getDepartmentList()
      if (resp.code === 1000) {
        let departmentList = resp.data
        for (let department of departmentList) {
          let option02 = {value: department.id, label: department.name}
          this.options_02.push(option02)
        }
      } else {
        this.$message.error('请求数据失败')
      }
    },
    async getPresetList () {
      // 请求部位数据
      let response = await getPresetList()
      if (response.code === 1000) {
        let presetList = response.data
        for (let preset of presetList) {
          let option03 = {value: preset.preset_id, label: preset.preset_name}
          this.options_03.push(option03)
        }
      } else {
        this.$message.error('请求数据失败')
      }
    },
    searchConditionChange (val) {
      if (val.isBackToOne) {
        this.pageNum = 1
      }
      this.getOrderList()
    },
    isDisable (row) {
      // if (row.image_url === '' || row.image_url.indexOf('jpg') === -1) {
      if (row.image_url === '' ) {
        return true
      }
      return false
    },
    tableRowClassName ({row, rowIndex}) {
      if (rowIndex === this.selectedIndex) {
        return 'success-row'
      }
      return ''
    },
    beforeHandleCommand (row, command) {
      return {
        'row': row,
        'command': command
      }
    },
    // 刷新
    refresh () {
      this.getOrderList()
    },
    // 获取用户当前所属医院的医院ID
    async getHospitalId () {
      let that = this
      let resp = await getUserInfo({
        username: that.$store.getters.getUser.account
      })
      if (resp.code === 1000) {
        that.currentHospitalId = resp.data.currentHospitalId
      } else {
        that.$message.error('请求数据失败')
      }
    },
    getOrderType (row, column) {
      if (row.type === 1) {
        return '同步'
      }
      if (row.type === 2) {
        return '异步'
      }
    },
    getDepartment (row, column) {
      let pre
      let dep
      for (let object of this.options_02) {
        if (row.department_id === object.value) {
          pre = object.label
        }
      }
      for (let object of this.options_03) {
        if (row.preset_id === object.value) {
          dep = object.label
        }
      }
      return pre + '/' + dep
    },
    getLocation (row, column) {
      if (row.city === null) {
        return '无'
      }
      return row.city + '/' + row.district
    },
    getPreset (row, column) {
      for (let object of this.options_03) {
        if (row.preset_id === object.value) {
          return object.label
        }
      }
    },
    getCreateTime (row, column) {
      return JsUtill.methods.getTime(row.create_date)
    },
    getPatientMsg (row, column) {
      return (row.sex === 0 ? '女' : '男') + '/' + row.age
    },
    handleCurrentChange (currentPageNum) {
      this.pageNum = currentPageNum
      this.getOrderList()
    },
    // 点击预览触发该方法
    handlePreview (row, index) {
      this.selectedIndex = index
      this.$router.push({name: 'EditReport', params: {orderSn: row.order_sn, departmentList: this.options_02, presetList: this.options_03, isEdit: false}})
    },
    // 点击接单以后触发该方法
    handleClick (row) {
      let that = this
      that.$confirm('请选择接下来的操作?', '提示', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确定接单',
        cancelButtonText: '编辑报告',
        type: 'warning'
      }).then(() => {
        getOrder({
          expert_id: that.$store.getters.getUser.account,
          order_sn: row.order_sn,
          type: row.type
        }).then(resp => {
          if (resp.code === 1000) {
            this.$message.success('接单成功')
            that.getOrderList()
          } else {
            this.$message.error(resp.msg)
          }
        })
      }).catch(action => {
        if (action === 'cancel') {
          getOrder({
            expert_id: that.$store.getters.getUser.account,
            order_sn: row.order_sn,
            type: row.type
          }).then(resp => {
            if (resp.code === 1000) {
              this.$message.success('接单成功')
              this.$router.push({name: 'EditReport', params: {orderSn: row.order_sn, departmentList: this.options_02, presetList: this.options_03, isEdit: true}})
            } else {
              this.$message.error(resp.msg)
            }
          })
        }
      })
    },
    payNewOrder (row) {
      let that = this
      that.$confirm('请选择接下来的操作?', '提示', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确认支付',
        cancelButtonText: '取消支付',
        type: 'warning'
      }).then(() => {
        payOrder({
          orderSn: row.order_sn,
        }).then(resp => {
          if (resp.code === 1000) {
            this.$message.success('支付成功')
            that.getOrderList()
          } else {
            this.$message.error(resp.msg)
          }
        })
      })
    },
    refundOrder (row) {
      let that = this
      that.$confirm('请选择接下来的操作?', '提示', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确认退款',
        cancelButtonText: '取消退款',
        type: 'warning'
      }).then(() => {
        refundOrder({
          orderSn: row.order_sn,
        }).then(resp => {
          if (resp.code === 1000) {
            this.$message.success('退款成功')
            that.getOrderList()
          } else {
            this.$message.error(resp.msg)
          }
        })
      })
    },
    changeQC (val) {
      let that = this
      controllerOrder([{
        orderSn: val.row.order_sn,
        orderLevel: val.command,
        userType: 4
      }]).then((resp) => {
        if (resp.code === 1000) {
          that.getOrderList()
        } else {
          that.$message.error(resp.msg)
        }
      })
    },
    changePrescribe (val) {
      let that = this 
      var orderSn = val.row.order_sn
      changePrescribe({
        orderSn: orderSn,
        // prescribeStatus: val.command,
        // userType: 4
        
      }).then((resp) => {
        if (resp.code === 1000) {
          that.getOrderList()
        } else {
          that.$message.error(resp.msg)
        }
      })
      console.log("修改订单", orderSn);
    },
    getOrderList () {
      this.loading = true
      let that = this
      let isAll = 0
      let normal = 0
      let qc1 = 0
      let qc2 = 0
      let qc3 = 0
      let qc0 = 0
      let curSearchCondition = null
      if (this.type === 0) {
        curSearchCondition = this.$store.state.searchCondition.getOrder
      } else if (this.type === 1) {
        curSearchCondition = this.$store.state.searchCondition.magOrder
      } else if (this.type === 2) {
        curSearchCondition = this.$store.state.searchCondition.reportOrder
      } else if (this.type === 3) {
        curSearchCondition = this.$store.state.searchCondition.allOrder
      } else if (this.type === 4) {
        curSearchCondition = this.$store.state.searchCondition.payOrder
      } else if (this.type === 5) {
        curSearchCondition = this.$store.state.searchCondition.refundOrder
      } else if (this.type === 6) {
        curSearchCondition = this.$store.state.searchCondition.classicalOrder
      }
      let qcStatus = curSearchCondition.qcStatus
      if (qcStatus.length === 0) {
        isAll = 1
      } else {
        if (qcStatus.find(value => value === 0) != null) {
          normal = 1
        }
        if (qcStatus.find(value => value === 1) != null) {
          qc1 = 1
        }
        if (qcStatus.find(value => value === 2) != null) {
          qc2 = 1
        }
        if (qcStatus.find(value => value === 3) != null) {
          qc3 = 1
        }
        if (qcStatus.find(value => value === -1) != null) {
          qc0 = 1
        }
      }
      let durationStart = curSearchCondition.durationStart.getTime()
      let durationEnd = curSearchCondition.durationEnd.getTime() + 1000 * 60 * 60 * 24
      let department = curSearchCondition.department
      let preset = curSearchCondition.preset
      let inputSearch = curSearchCondition.inputSearch
      let orderType = curSearchCondition.orderType
      if (durationStart > durationEnd) {
        this.$message.error('结束时间不能小于开始时间')
        return
      }
      getOrderList({
        departmentId: department,
        pageNum: that.pageNum,
        pageSize: that.pageSize,
        type: orderType,
        presetId: preset,
        hospitalId: that.currentHospitalId,
        inputSearch: inputSearch,
        durationStart: durationStart,
        durationEnd: durationEnd,
        isAll: isAll,
        normal: normal,
        qc1: qc1,
        qc2: qc2,
        qc3: qc3,
        qc0: qc0,
        orderYunyingType: this.type,
        expertId: that.$store.getters.getUser.account
      }).then((response) => {
        if (response.code === 1000) {
          that.tableData = response.data.data
          that.total = response.data.total
          that.loading = false
        } else {
          this.$message.error('请求数据失败')
          that.loading = false
        }
      })
    },
    // 编辑报告调用方法
    editReport (val, index) {
      this.selectedIndex = index
      this.$router.push({name: 'EditReport', params: {orderSn: val.order_sn, departmentList: this.options_02, presetList: this.options_03, isEdit: true}})
    },
    viewReport (val, index) {
      this.selectedIndex = index
      this.$router.push({name: 'EditReport', params: {orderSn: val.order_sn, departmentList: this.options_02, presetList: this.options_03, isEdit: false, isFinish: true}})
    },
    // 查看报告调用方法
    checkReport (val, index) {
      this.selectedIndex = index
      this.$router.push({name: 'ProduceReport', params: {orderSn: val.order_sn, departmentList: this.options_02, presetList: this.options_03}})
    }
  }
}
</script>

<style scoped>
@import "../../assets/css/main.css";

.el-divider {
  margin-bottom: 0px;
  margin-top: 15px;
}
@media (max-width: 900px) {
  .page {
    display: none;
  }
}
@media (min-width: 900px) {
  .page-phone {
    display: none;
  }
}
.page {
  width: 400px;
  margin: 0px auto;
}
@media (max-width: 500px) {
  /deep/ .page.el-pagination.is-background {
    width: 100%;
    overflow: hidden;
  }
}
.el-message-box {
  width: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/home/Order.vue